import { clsx } from 'clsx';

interface ProgressBarProps {
  value: number;
  variant?: 'primary' | 'success' | 'warning' | 'error';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  value,
  variant = 'primary',
  size = 'md',
  className
}) => {
  const clampedValue = Math.min(100, Math.max(0, value));
  
  const heights = {
    sm: 'h-2',
    md: 'h-3',
    lg: 'h-4',
  };
  
  const variants = {
    primary: 'bg-primary-600',
    success: 'bg-green-600',
    warning: 'bg-yellow-600',
    error: 'bg-red-600',
  };
  
  return (
    <div 
      className={clsx(
        'w-full bg-gray-200 rounded-full overflow-hidden',
        heights[size],
        className
      )}
    >
      <div
        className={clsx(
          'h-full transition-all duration-300 ease-out',
          variants[variant]
        )}
        style={{ width: `${clampedValue}%` }}
      />
    </div>
  );
};